<template>
 <AdminPanelEpicentrkMegogoPackageSellingHistory />
</template>

<script>
import AdminPanelEpicentrkMegogoPackageSellingHistory from '../components/AdminPanelEpicentrkMegogoPackageSellingHistory.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEpicentrkMegogoPackageSellingHistory
    },
    methods: {},
    mounted() {}
}
</script>
